import React from 'react';

import css from './SectionFounders.module.css';
import { FormattedMessage } from 'react-intl';
import nunoImage from './images/nuno-profile-pic.jpg';
import jacoImage from './images/jaco-profile-pic.jpg';
import LinkedInIcon from './images/LinkedInIcon';

const SectionFounders = props => {
  const { intl } = props;
  const nunoLink = intl.formatMessage({ id: 'AboutUsPage.nunoFounder.link' });
  const jacoLink = intl.formatMessage({ id: 'AboutUsPage.jacoFounder.link' });
  return (
    <div className={css.root}>
      <h1 className={css.title}>
        <FormattedMessage id="AboutUsPage.ourFounders" />
      </h1>
      <div className={css.horizontalWrapper}>
        <div className={css.verticalWrapper}>
          <img className={css.image} src={nunoImage} />
        </div>

        <div className={css.verticalWrapper}>
          <div className={css.header}>
            <div>
              <p className={css.name}>
                <FormattedMessage id="AboutUsPage.nunoFounder.name" />
              </p>
              <p className={css.position}>
                <FormattedMessage id="AboutUsPage.nunoFounder.position" />
              </p>
            </div>
            <div className={css.icon}>
              <a href={nunoLink}>
                <LinkedInIcon />
              </a>
            </div>
          </div>

          <ul className={css.list}>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list1" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list2" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list3" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list4" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list5" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list6" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.nunoFounder.list7" />
            </li>
          </ul>
        </div>
      </div>
      <div className={css.horizontalWrapper}>
        <div className={css.verticalWrapper}>
          <div className={css.header}>
            <div>
              <p className={css.name}>
                <FormattedMessage id="AboutUsPage.jacoFounder.name" />
              </p>
              <p className={css.position}>
                <FormattedMessage id="AboutUsPage.jacoFounder.position" />
              </p>
            </div>
            <div className={css.icon}>
              <a href={jacoLink}>
                <LinkedInIcon />
              </a>
            </div>
          </div>

          <ul className={css.list}>
            <li>
              <FormattedMessage id="AboutUsPage.jacoFounder.list1" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.jacoFounder.list2" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.jacoFounder.list3" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.jacoFounder.list4" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.jacoFounder.list5" />
            </li>
            <li>
              <FormattedMessage id="AboutUsPage.jacoFounder.list6" />
            </li>
          </ul>
        </div>
        <div className={css.verticalWrapper}>
          <img className={css.image} src={jacoImage} />
        </div>
      </div>
    </div>
  );
};

export default SectionFounders;
